import { twJoin } from 'tailwind-merge';

import { Skeleton } from '@/_components';

import { Layout } from './layout';

function LoadingContent({ className }: { className?: string }) {
  return (
    <article className={twJoin('@container flex h-full flex-col justify-between gap-6', className)}>
      {/* Header with Filters Skeleton */}
      <section className="flex flex-row flex-wrap items-center justify-between">
        <div>
          <Skeleton className="h-8 w-32 rounded-xl" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-8 w-32 rounded-xl" />
        </div>
      </section>

      {/* Chart Skeleton */}
      <div className="min-h-[290px] w-full">
        <Skeleton className="h-full w-full rounded-xl" />
      </div>

      {/* Sales Summary Cards Skeleton */}
      {/* <section className="mt-12 grid w-full grid-cols-1 gap-3 @lg:grid-cols-12 @lg:gap-6">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-4 @md:col-span-4 dark:border-gray-700 dark:bg-gray-800"
          >

            <div className="flex items-center justify-center gap-2 border-b border-gray-100 pb-3 dark:border-gray-700">
              <Skeleton className="h-2 w-2 rounded-full" />
              <Skeleton className="h-4 w-32 rounded" />
            </div>


            <div className="rounded-xl bg-gray-100 p-4 dark:bg-gray-700">
              <div className="flex items-center gap-3">
                <Skeleton className="h-10 w-10 rounded-full" />
                <div className="flex-1 space-y-1">
                  <Skeleton className="h-3 w-20 rounded" />
                  <Skeleton className="h-5 w-16 rounded" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </section> */}

      <div className="grid grid-cols-1 gap-6 @lg:grid-cols-3">
        {/* Detailed Data Accordion Skeleton */}
        <div className="col-span-2 h-12 @lg:col-span-1">
          <div className="overflow-hidden rounded-xl border border-gray-200 dark:border-gray-700">
            {/* Accordion Header Skeleton */}
            <div className="flex items-center justify-between rounded-t-lg bg-gray-50 px-4 py-4 dark:bg-gray-800">
              <Skeleton className="h-4 w-40 rounded" />
              <Skeleton className="h-4 w-4 rounded" />
            </div>
          </div>
        </div>
        <div className="col-span-2 h-12">
          <Skeleton className="h-full w-full rounded-xl" />
        </div>
      </div>
    </article>
  );
}

export function AnnualHistoricalSalesLoading({ className, layout = false }: { className?: string; layout?: boolean }) {
  return layout ? (
    <Layout>
      <LoadingContent className={className} />
    </Layout>
  ) : (
    <LoadingContent className={className} />
  );
}
